// Google Analytics 4 helper
// Replace with your real GA4 Measurement ID (starts with G-)
export const GA_MEASUREMENT_ID = "G-XJ2BG17VYE";

// Track custom events
export const trackEvent = (
  eventName: string,
  params?: Record<string, string | number | boolean>
) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, params);
  }
};

// Pre-built event trackers
export const trackWhatsAppClick = (listingId?: string, category?: string) => {
  trackEvent("whatsapp_click", {
    listing_id: listingId || "general",
    category: category || "unknown",
  });
};

export const trackTourView = (listingId: string, title: string) => {
  trackEvent("tour_view", {
    listing_id: listingId,
    tour_title: title,
  });
};

export const trackBookInspection = (listingId: string, location: string) => {
  trackEvent("book_inspection", {
    listing_id: listingId,
    location,
  });
};

// Extend Window for gtag
declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}
